import anime from 'animejs/lib/anime.es.js';

/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   Simple accordion pattern example
 *   I clearly edited the shit out of this.
 */

'use strict';

export default class Accordion {
    constructor(domNode) {
        this.animation = null;
        this.buttonEl = domNode;
        this.controlsId = this.buttonEl.getAttribute('aria-controls');
        this.contentEl = document.getElementById(this.controlsId);
        // This gives a lil extra height to the accordion depending on how many children it has to prevent clipping
        this.verticalPadding = (this.contentEl.children.length + 2) * 16;
        this.contentElHeight = this.contentEl.scrollHeight + this.verticalPadding;
        this.closePanel();
        this.open = this.buttonEl.getAttribute('aria-expanded') === 'true';
        this.buttonEl.addEventListener('click', this.onButtonClick.bind(this));
    }

    closePanel() {
        this.contentEl.style.maxHeight = '0';
        this.contentEl.querySelectorAll('*').forEach(el => el.setAttribute('tabindex', -1));
    }

    onButtonClick() {
        this.toggle(!this.open);
    }

    toggle(open) {
        // don't do anything if the open state doesn't change
        if (open === this.open) {
            return;
        }

        // update the internal state
        this.open = open;

        // handle DOM updates
        this.buttonEl.setAttribute('aria-expanded', `${open}`);
        if (open) {
            this.contentEl.removeAttribute('hidden');
            this.contentEl.querySelectorAll('*').forEach(el => el.removeAttribute('tabindex'));
            this.accordionAnimation(true);
        } else {
            this.contentEl.setAttribute('hidden', '');
            this.contentEl.querySelectorAll('*').forEach(el => el.setAttribute('tabindex', -1));
            this.accordionAnimation(false);
        }
    }

    // Add public open and close methods for convenience
    open() {
        this.toggle(true);
    }

    close() {
        this.toggle(false);
    }

    accordionAnimation(animateIn = true) {
        // Pause and remove any existing animations
        if (this.animation) {
            this.animation.pause();
            this.animation = null;
        }

        // anime is a global script
        this.animation = anime({
            targets: this.contentEl,
            maxHeight: animateIn ? this.contentElHeight : "0",
            easing: "easeOutExpo",
            duration: 800
        });
    }
}
